export const checkMax = (value: number, max: number) => (value > max ? `Maximum is ${max}` : '')

export const checkMaxAsync = (value: number, max: number) => Promise.resolve(checkMax(value, max))
